// @flow

import type { UserInputValidationErrorPayload } from './types';
import { SERVER_ERROR_MESSAGE } from './constants';

export function serverErrorMessage(payload: ?UserInputValidationErrorPayload, fallback?: string = SERVER_ERROR_MESSAGE): string {
  return payload && payload.message || fallback;
}
